import apiClient from './apiClient';
const URL = process.env.REACT_APP_API_URL + "/cursos";

export const getCursos = async (busqueda = "", estado = "") => {
    try {
        let url = `${URL}?busqueda=${busqueda}`;
        if (estado) {
            url += `&estado=${estado}`;
        }
        const response = await apiClient(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (response.status === 404) {
            return [];
        }
        if (response.status !== 200) {
            throw new Error("No se encontraron los cursos");
        }
        const data = await response.json();

        return data
    } catch (error) {
        throw error
    }
}


export const postCurso = async (curso) => {
    try {

        const response = await apiClient(URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ ...curso })
        });
        const data = await response.json();
        if (response.status !== 201) {
            throw new Error(data.message || "Error al registrar el curso");
        }

        return data
    } catch (error) {
        throw error
    }
}


export const putCurso = async (curso) => {
    try {



        const response = await apiClient(URL, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ...curso
            })
        });


        const data = await response.json();
        if (response.status !== 200) {
            throw new Error(data.message || "Error al registrar el curso");
        }

        return data
    } catch (error) {
        throw error
    }
}


export const deleteCurso = async (cod) => {
    try {
        const response = await apiClient(`${URL}/${cod}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = await response.json();
        if (response.status !== 200) {
            throw new Error(data.message || "Error al eliminar el curso");
        }

        return data;
    } catch (error) {
        throw error;
    }
};


export const patchEstadoCurso = async (cod, accion, estadoDestino = null) => {
    try {
        const body = { accion };
        if (estadoDestino) body.estadoDestino = estadoDestino;

        const response = await apiClient(`${URL}/${cod}/estado`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });

        const data = await response.json();
        if (response.status !== 200) {
            throw new Error(data.message || "Error al cambiar el estado del curso");
        }

        return data;
    } catch (error) {
        throw error;
    }
}

export const quickCreateCurso = async (nombre, cantidad_horas) => {
    try {
        const response = await apiClient(`${URL}/quick-create`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ nombre, cantidad_horas })
        });
        const data = await response.json();
        if (response.status !== 201) {
            throw new Error(data.message || "Error al registrar el curso");
        }
        return data;
    } catch (error) {
        throw error;
    }
};

export const postCursoParaNota = async (curso) => {
    try {
        const response = await apiClient(`${URL}/crear-para-nota`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ ...curso })
        });
        const data = await response.json();
        if (response.status !== 201) {
            throw new Error(data.message || "Error al crear el curso desde nota de autorización");
        }
        return data;
    } catch (error) {
        throw error;
    }
};
